export enum ButtonType {
  DEFAULT = 'DEFAULT',
  STROKED = 'STROKED',
  RAISED = 'RAISED',
}
